import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import {
  DEV_URL,
  SHOW_TRANSLATION_ID,
  SITE_LANGUAGE,
} from '../constants/constants';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from './utils.service';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private isInitialLoad = true;
  static data: any = {};
  public translationsChanged$ = new Subject();
  static showTranslationId: boolean = false;

  constructor(private http: HttpClient, private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      const isDev = window.location.host.startsWith(DEV_URL);

      TranslateService.showTranslationId =
        (UtilsService.isLocalHost() || isDev) &&
        Boolean(params[SHOW_TRANSLATION_ID]);
    });
  }

  use(lang: string): Promise<{}> {
    return new Promise<{}>((resolve) => {
      lang =
        Object.values(SITE_LANGUAGE).find((val) => val === lang) ??
        SITE_LANGUAGE.EN;

      const langPath = `./assets/locale/${lang}.json`;

      this.http.get(langPath).subscribe(
        (response) => {
          TranslateService.data = response || {};

          resolve(TranslateService.data);

          if (this.isInitialLoad) {
            this.isInitialLoad = false;
          } else {
            this.translationsChanged$.next(true);
          }
        },
        () => {
          TranslateService.data = {};
          resolve({});
        }
      );
    });
  }

  static translate(key: string): string {
    if (TranslateService.showTranslationId) {
      return `translation ID: ${key}`;
    }

    if (key in TranslateService.data) {
      return TranslateService.data[key] ?? '';
    }

    return environment.production ? '' : `translation for [${key}] missing`;
  }
}
